import React from "react";
import { cn } from "./ui/utils";

/**
 * White underlay that survives MAX / Chromium Force Dark.
 * CSS `background-color: #fff` is inverted; a real white SVG <img> is not.
 */
const WHITE_SVG =
  "data:image/svg+xml," +
  encodeURIComponent(
    '<svg xmlns="http://www.w3.org/2000/svg" width="8" height="8"><rect width="8" height="8" fill="#ffffff"/></svg>',
  );

const plateStyle: React.CSSProperties = {
  colorScheme: "only light",
  forcedColorAdjust: "none",
  WebkitForcedColorAdjust: "none",
};

export function WhiteLogoPlate({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn("relative overflow-hidden", className)}
      style={plateStyle}
      data-logo-plate="1"
    >
      <img
        src={WHITE_SVG}
        alt=""
        aria-hidden
        draggable={false}
        className="absolute inset-0 w-full h-full object-cover pointer-events-none select-none"
        style={plateStyle}
      />
      <div className="relative z-[1] flex items-center justify-center w-full h-full">
        {children}
      </div>
    </div>
  );
}
